import React, { useState } from 'react';
import { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import MathRenderer from "../components/taskUser copy 3.js"
import { useReactToPrint } from 'react-to-print'
import { useRef } from "react";
// import axios from "axios"
import { isAuth } from '../helpers/auth';
import { parseISO } from "date-fns";

const ExportToExcel = ({ idtheme, codetheme, usser }) => {
  const [evaluacion, setEvaluacion] = useState('')
  const [datew, setDatew] = useState('')
  const [dateww, setDateww] = useState('')
  const [data, setData] = useState([])
  const [showModal, setshowModal] = useState(false)
  const [noww, setDateNow] = useState(new Date())

  const componentRef = useRef(null);

  const handlePrint = useReactToPrint({
    documentTitle: 'Title',
    content: () => componentRef.current,

  });



  useEffect(() => {
    getTask()
  }, []);

  const getTask = async () => {
    fetch(`${process.env.REACT_APP_API_URL}/tasks/test/${idtheme}/${codetheme}/${usser}`)
      .then((response) => response.json())
      .then(async (www) => {
        console.log(www[0], "zzz")

        if (www[0]) {
          setData(www[0].items)
          setDateww(parseISO(www[0].datee))
          setDatew(parseISO(www[0].dateb))
          setEvaluacion(www[0].note)
        } else { }

      })
  };

  const open = () => setshowModal(true);
  const close = () => setshowModal(false);

  return (
    <>

      <Modal show={showModal} onHide={() => { close() }} animation={false} >
        <div className="modal-header font-weight-bold ">
        </div>
        <Modal.Body>
          <div ref={componentRef} >
            <div className='row justify-content-center align-items-center border d-flex p-1' style={{ margin: '.5em' }}>
              {data.length > 0 ?
                data.map((number, i) =>
                  <div key={i + 1} className={`${number.alt ? 'col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1' : 'col-sm-12 col-md-12 col-lg-12 p-1'}`}>
                    [{i + 1}]
                      <div className="rounded text-primary">
                    <MathRenderer>
                      {number.prg}
                    </MathRenderer>
                      </div>
                    {number.alt ?
                      <div className="rounded text-info">
                        <MathRenderer>
                          {number.std}
                        </MathRenderer>
                      </div>
                      :
                      <div className="">
                        <MathRenderer>
                          {number.std}
                        </MathRenderer>
                        <div className="rounded text-warning">
                          <MathRenderer>
                            {number.obs}
                          </MathRenderer>
                        </div>
                      </div>
                    }
                  </div>
                ) : ''
              }
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-info" data-dismiss="modal" onClick={() => handlePrint()} >
            Imprimir
          </button>
          <button type="button" className="btn btn-warning" data-dismiss="modal" onClick={() => { close() }} >
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>

      {data.length === 0 ? '' :
        <button type="button" className='btn btn-outline-info mb-1' onClick={() => { open() }}>
          <div className='text-center font-weight-bold'>
            {datew < noww && noww < dateww ? '' :
              <>{evaluacion === 0 ? '' : `Crédito ${evaluacion}`}</>
            }
          </div>
        </button>
      }

      
      {/* {
      isAuth().rol === '1' ? 
      <div>
        {data.length === 0 ? '' : 
        <div className='text-center font-weight-bold text-info'>
          <>{evaluacion === 0 ? '' : `Crédito ${evaluacion}`}</>
        </div>}
      </div> :
        <div>
          {data.length === 0 ? '' : <div className='text-center font-weight-bold text-info'>
            {datew < noww && noww < dateww ? '' :
              <>{evaluacion === 0 ? '' : `Crédito ${evaluacion}`}</>
            }
          </div>
          }
        </div>} */}
    </>
  );
};

export default ExportToExcel